import { ReactElement, RefObject, SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { PostListItem, ReactionStats, useTargetDetailsQuery } from 'api';
import { Spinner } from 'components';
import { useCompanyDetails } from 'components/Dialogs/hooks';
import { PostTopBar } from 'components/PostTopBar';
import { ReactionsWrapper } from 'components/ReactionsWrapper';
import { TargetItem } from 'features/kpi';
import { Links } from 'settings';
import { InViewItemRef } from 'types';

import { Container, LeftSide, PostContentWrapper, PostTitle, PostW } from '../styled';
import { LinkW, PostDescription, TargetW } from './styled';

interface KpiTargetPostProps {
  id: string;
  author: PostListItem['author'];
  publishedAt: string;
  reactions?: ReactionStats;
  comments_count?: number;
  targetId: string;
  postRef: RefObject<HTMLDivElement>;
  lastItemRef?: InViewItemRef;
  handlePostClick?: () => void;
  handleOpenReactionModal?: () => void;
  isSlider?: boolean;
}

export function KpiTargetPost({
  id,
  author,
  publishedAt,
  targetId,
  reactions,
  comments_count,
  postRef,
  lastItemRef,
  handlePostClick,
  handleOpenReactionModal,
  isSlider,
}: KpiTargetPostProps): ReactElement {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isLoading, data } = useTargetDetailsQuery(targetId);

  const { company } = useCompanyDetails();

  function handleLinkClick(e: SyntheticEvent) {
    e.stopPropagation();
    navigate(Links.we.kpi.index);
  }

  return (
    <Container ref={postRef}>
      <PostW ref={lastItemRef} sx={{ maxHeight: 'unset' }} isSlider={isSlider}>
        <PostContentWrapper>
          <PostTopBar
            id={id}
            publishedAt={publishedAt}
            postTitle={t('completedKpiTargetPost.title')}
            authorName={company?.name || ''}
            isAutomatedPost
            author={author}
          />
          <LeftSide>
            <PostTitle>{t('completedKpiTargetPost.title')}</PostTitle>
            <PostDescription>{t('completedKpiTargetPost.description1')}</PostDescription>

            <TargetW>
              {isLoading && <Spinner />}
              {data?.data && !isLoading && <TargetItem {...data?.data} isFromPost />}
            </TargetW>

            <PostDescription>{t('completedKpiTargetPost.description2')}</PostDescription>
            <LinkW onClick={handleLinkClick}>{t('completedKpiTargetPost.link')}</LinkW>
          </LeftSide>
        </PostContentWrapper>
        <ReactionsWrapper
          id={id}
          isPreview={false}
          reactions={reactions}
          comments_count={comments_count}
          handlePostClick={handlePostClick}
          handleOpenReactionModal={handleOpenReactionModal}
        />
      </PostW>
    </Container>
  );
}
